module.exports = __webpack_public_path__ + "static/footer-background-small-09afacb58ae53ebf487bb41922940660.jpg";